/**
 * Click to Remove Element — element hider
 *
 * A minimal extension: its single web-accessible-resource entry exposes exactly one file,
 * `content.css`, matched to every http(s) origin with no `use_dynamic_url`. That one path
 * is fetchable from any page at a fixed URL, so a single fetch is conclusive. There is no
 * image or second resource to corroborate with, so this detector has one primary signal.
 *
 * Manifest verified against version 3.1.5.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jcgpghgjhhahcefnfpbncdmhhddedhnk';

export const clickToRemoveElement: ExtensionDefinition = {
  id: ID,
  name: 'Click to Remove Element',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 90_000,
  notes:
    'Exposes a single WAR (content.css) to every http(s) origin with no dynamic URL. ' +
    'Detection is a single fetch and conclusive; there is no second path to corroborate.',
  signals: [
    {
      id: 'war-content-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content.css — the extension\'s only web-accessible resource, exposed to ' +
        'every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'content.css'),
    },
  ],
};
